import * as Modal from './styles'

export default Modal
